<template lang="html">
  <div>
    <span class="text muted small">
      Receiving the following {{ this.notificationType }} notifications:
      <b-button :class="visible ? null : 'collapsed'"
                :aria-expanded="visible ? 'true' : 'false'"
                aria-controls="collapse-notification-preferences"
                @click="visible = !visible"
                variant="secondary"
                size="sm" :title=getButtonTitle()>
        <i class="fa-solid fa-bell fa-md"></i>
        <i v-if="!visible" class="fa-solid fa-arrow-down fa-2xs"></i>
        <i v-else class="fa-solid fa-arrow-up fa-2xs"></i>
    </b-button>
    </span>
    <b-collapse class="mt-1" id="collapse-notification-preferences" v-model="visible">
      <b-link :to="{name: 'ProjectNotifications'}" target="_blank" rel="noopener noreferrer"> All Notification Settings <i class="fas fa-external-link-alt fa-2xs"></i></b-link>
      <b-table
        bordered
        :items="memberPrefs"
        :fields="tableFields"
        thead-class="text muted small">
        <template v-slot:cell(type)="row">
          <span class="text muted small">{{ row.item.type }}</span>
        </template>
        <template v-slot:cell(emailNotify)="row">
          <b-form-checkbox
            v-model="row.item.emailNotify"
            :value=true
            :unchecked-value=false
            @change="update(row.item)"
            switch
            size="sm">
          </b-form-checkbox>
        </template>
        <template v-slot:cell(webNotify)="row">
          <b-form-checkbox
            v-model="row.item.webNotify"
            :value=true
            :unchecked-value=false
            @change="update(row.item)"
            switch
            size="sm">
          </b-form-checkbox>
        </template>
      </b-table>
    </b-collapse>
  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import VueLoader from "../../../layout/Loader.vue";
import DateTime from "../../../common/date-time/DateTime.vue";
import {NOTIFICATION_TYPES} from "../../../../constants/notification_types"

export default {
  name: "ProjectNotificationStatus",
  components: {DateTime, VueLoader},
  props: {
    notificationType: String,
  },
  data() {
    return {
      memberPrefs: null,
      tableFields: [
        {
          key: "type",
          label: "Notification Type",
          sortable: false,
          sortDirection: "asc",
          tdClass: "text-left",
          thClass: "'text muted small'"
        },
        {
          key: "emailNotify",
          label: "Email",
          sortable: false,
          class: "text-center",
          thClass: "'text muted small'",
        },
        {
          key: "webNotify",
          label: "Web",
          class: "text-center",
          thClass: "'text muted small'",
        },
      ],
      visible: false,
    };
  },
  created() {
    if (this.projectVuex && this.memberIRI) {
      this.projectPreferences({memberId: this.memberIRI})
    }
  },
  watch: {
    projectVuex(newVal) {
      if (newVal) {
        this.projectPreferences({memberId: this.memberIRI})
      }
    },
    memberPreferences(newVal) {
      if (newVal) {
        this.memberPrefs = newVal.map(pref => ({type: NOTIFICATION_TYPES[pref['notificationType']], ...pref}))
        this.memberPrefs = this.memberPrefs.filter(val => {
          return val.notificationType.includes(this.notificationType)
        })

      }
    },
  },
  computed: {
    ...mapGetters({
      projectVuex: "project/get/project",
      projectId: "project/get/id",
      isMember: "project/get/isMember",
      memberIRI: "project/get/memberIRI",
      memberPreferences: "user/notification_preference/memberPreferences"
    }),
  },

  methods: {
    ...mapActions({
      projectPreferences: "user/notification_preference/getProjectMemberPrefs",
      addUpdateMemberPref: "user/notification_preference/addUpdateMemberPref",
    }),
    update(pref) {
      this.addUpdateMemberPref(pref)
    },
    getButtonTitle() {
      let title = this.visible ? 'Collapse' : 'Expand'
      return 'Click to ' + title
    },
  }
}
</script>

<style scoped lang="scss">
</style>

